import { StyledSeparator } from "./Separator.Styled";

const Separator = ({ color, className, margin }) => (
  <StyledSeparator color={color} className={className} margin={margin} />
);

export default Separator;
